export default "__VITE_ASSET__C193KPJ9__"